import React from 'react';
import {
  CalendarToday,
  LocationOn,
  People,
  Restaurant,
  Celebration,
  EmojiObjects
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import ImageCarousel from '../../components/events/ImageCarousel';
import EventMeta from '../../components/events/EventMeta';
import KeyTakeaways from '../../components/events/KeyTakeaways';

const RoshHashana2024 = () => {
  const eventData = {
    title: 'Rosh Hashanah Celebration at EPFL',
    category: 'Cultural Event',
    date: '10/1/2024',
    location: 'EPFL Campus',
    description: 'We celebrated Rosh Hashanah, the Jewish New Year, with the EPFL community. Students and staff joined us to learn about this important holiday while enjoying traditional treats. We shared the beautiful custom of eating apples with honey, symbolizing wishes for a sweet new year ahead.',
    media: [
      { src: '/events/rosh24/rosh1.jpg', objectFit: 'cover', objectPosition: '50% 65%' },
      { src: '/events/rosh24/rosh2.jpg', objectFit: 'cover', objectPosition: '50% 50%' }
    ],
    keyTakeaways: [
      {
        icon: <People style={{ fontSize: '24px' }} />,
        title: 'Community Engagement',
        description: 'Over 100 people from the EPFL community joined us to learn about and celebrate this important Jewish holiday.',
        color: '#4F8EF7'
      },
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Traditional Treats',
        description: 'We shared apples with honey and sugar candy, allowing everyone to experience this sweet New Year tradition.',
        color: '#9C88FF'
      },
      {
        icon: <EmojiObjects style={{ fontSize: '24px' }} />,
        title: 'Cultural Exchange',
        description: 'Visitors learned about the significance of Rosh Hashanah in Jewish and Israeli culture.',
        color: '#50E3C2'
      },
      {
        icon: <Celebration style={{ fontSize: '24px' }} />,
        title: 'Festive Atmosphere',
        description: 'Created a warm and welcoming environment for sharing cultural traditions with the EPFL community.',
        color: '#FF6B9D'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4F8EF7, #9C88FF)',
      title: 'October 1st, 2024',
      subtitle: 'Event Date'
    },
    {
      icon: <LocationOn style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: eventData.location,
      subtitle: 'Location'
    },
    {
      icon: <People style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: '100+ Visitors',
      subtitle: 'Attendance'
    }
  ];

  return (
    <EventLayout>
      <BackButton />
      <EventHero
        category={eventData.category}
        title={eventData.title}
        description={eventData.description}
      >
        <EventMeta items={metaItems} />
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
      />

      <KeyTakeaways items={eventData.keyTakeaways} />

      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        marginTop: '48px',
        marginBottom: '60px',
        textAlign: 'center',
        border: '1px solid rgba(0,0,0,0.1)'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: '1.5rem',
          color: 'var(--color-text)',
          marginBottom: '16px'
        }}>
          🍎 Shana Tova!
        </h3>
        <p style={{
          fontSize: '1rem',
          color: 'var(--color-text-light)',
          lineHeight: '1.6',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          Thank you to everyone who joined us in celebrating Rosh Hashanah! It was wonderful to share our traditions and sweet treats with the EPFL community. We hope the honey-dipped apples brought a touch of sweetness to your day!
        </p>
      </div>
    </EventLayout>
  );
};

export default RoshHashana2024;